export default {
    getSurveys(state) {
        return state.surveys;
    },
    getActiveSurveyID(state) {
        return state.activeSurveyID;
    },
    getActiveSurvey(state) {
        return state.activeSurvey;
    }
}